module.exports = __webpack_public_path__ + "static/media/moons_pago_SPEI_transferencia.3f81aa02.svg";